import { useContext } from 'react';
import { __RouterContext } from 'react-router';
export function useLocation() {
    var _a;
    return (_a = useContext(__RouterContext)) === null || _a === void 0 ? void 0 : _a.location;
}
